import React from 'react';
import PropTypes from 'prop-types';
import loginBackgroundImg from './illustrations/background.png';
import loginPlanetImg from './illustrations/planet.png';
import './login.scss';

function getLoginText(isParnerLogin = false) {
  return isParnerLogin ? 'Welcome back' : 'Welcome back to your store';
}

function getLoginSubtextFirstLine(isParnerLogin = false) {
  return isParnerLogin
    ? 'Log in to keep managing your apps.'
    : 'Log in to keep things moving.';
}

function getLoginSubtextSecondLine(isParnerLogin = false) {
  return isParnerLogin ? '' : 'New orders, messages, and stats are waiting.';
}

export default class LoginPageLeftPart extends React.PureComponent {
  static propTypes = {
    isPartnerLogin: PropTypes.bool,
  };

  render() {
    const { isPartnerLogin = false } = this.props;
    const subtextSecondLine = getLoginSubtextSecondLine(isPartnerLogin);

    return (
      <div
        className="auth-split_illustration"
        style={{ backgroundImage: `url(${loginBackgroundImg})` }}
      >
        <div className="auth-split_illustration-content">
          <h2>{getLoginText(isPartnerLogin)}</h2>
          <p>
            {getLoginSubtextFirstLine(isPartnerLogin)}
            {subtextSecondLine && <br />}
            {subtextSecondLine}
          </p>
        </div>
        <img
          className="auth-split_illustration-planet"
          src={loginPlanetImg}
          alt=""
        />
      </div>
    );
  }
}
